import { components } from "@certn/api/generated-schemas/client-portal";
import {
  Card,
  CheckboxFormikField,
  GridItem,
  Link,
  TextInputFormikField,
  Text,
} from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useField } from "formik";
import { Trans, useTranslation } from "react-i18next";

import { Question } from "./types";
interface Props {
  field: string;
  document: Question;
  question?: components["schemas"]["DefaultQuestionsResponse"];
}

export function DocumentQuestion({ document, field, question }: Props) {
  const { t } = useTranslation();
  const [selectedField] = useField(`${field}.selected`);
  const [promptField, , helpers] = useField(`${field}.prompt`);

  return (
    <GridItem>
      <Card
        className={css({
          borderColor: "var(--border-input-active)",
          padding: "var(--space-3)",
        })}
      >
        <CheckboxFormikField
          name={`${field}.selected`}
          testID={`${field}.selected`}
          description={document.prompt}
          aria-label={document.claim_name}
          isCard
          noBorder
        >
          {document.question}
        </CheckboxFormikField>
        {selectedField.value && (
          <div>
            <Link
              className={styles.reset}
              textStyle="global/body-secondary"
              textColor="text-info"
              testID={`${field}.reset`}
              target="_blank"
              onPress={() => helpers.setValue(question?.prompt)}
            >
              <Trans>Reset</Trans>
            </Link>
            <TextInputFormikField
              isRequired
              testID={`${field}.prompt`}
              name={`${field}.prompt`}
              value={promptField.value}
              label={t("Applicant instructions")}
            />
            {question?.claim_name === "other_document" && (
              <div className={styles.infoText}>
                <Text style="form/body-secondary" color="text-weak">
                  <Trans>
                    If the document(s) being requested are not covered by
                    Certn’s consent forms, you must explain to prospective
                    tenants the reason for collection, in accordance with
                    privacy laws.
                  </Trans>
                </Text>
              </div>
            )}
          </div>
        )}
      </Card>
    </GridItem>
  );
}

const styles = {
  reset: css({
    position: "absolute",
    right: "var(--space-4)",
  }),
  infoText: css({
    marginTop: "var(--space-3)",
  }),
};
